import 'select2/select2'

$(document).ready(function() {
  /* Apply Select2 on select boxes */
  $('#status-select').select2({
    minimumResultsForSearch: -1
  });
  $('#status-select').change(function() {
    this.form.submit();
  });
});
